import React, { useEffect, useState } from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';
import FooterComponent from '../../components/footer/FooterComponent';

const HomePage = React.memo(() => {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-online-sessions');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-online-sessions'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Header */}
          <HomePageHeader />
        </div>

        {/* Main page content */}
        <HomePageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
});

export default HomePage;
